import axios from "axios";

const cache = new Map();
const TTL = 5 * 60 * 1000; // 5 minutes

export function setupAxiosCache() {
  const originalGet = axios.get.bind(axios);

  axios.get = function cachedGet(url, config) {
    const hit = cache.get(url);
    if (hit && Date.now() - hit.ts < TTL) {
      return Promise.resolve(hit.res);
    }
    return originalGet(url, config).then((res) => {
      cache.set(url, { res, ts: Date.now() });
      return res;
    });
  };
}
